import { createPortal, useEffect, useState } from "preact/compat";
import { CloseOutlined } from "@ant-design/icons";
import { Drawer } from "antd";

export interface AnimationHelpModalProps {
  open: boolean;
  onClose: () => void;
  isMobile: boolean;
}

export default function AnimationHelpModal({ open, onClose, isMobile }: AnimationHelpModalProps) {
  const modalContent = <div className="content">
    <h3>Animate Options</h3>
    <p>Animations can be used with your Display playlists. To ensure proper playback, set the duration equal to the playlist slide duration.</p>
    <p><b>Both:</b> The animation will play when the slide appears on and leaves the screen.</p>
    <p><b>On Enter:</b> The animation will only play when the slide appears on the screen.</p>
    <p><b>On Exit:</b> The animation will only play when the slide leaves the screen.</p>
  </div>

  return open ?
  isMobile ?
  <Drawer
    className="alt-text-drawer alt-text-help-drawer"
    open={open} 
    onClose={onClose} 
    closeIcon={<CloseOutlined/>} 
    placement="bottom" 
    zIndex={120} 
    height={'55vh'}
    push={false}>
    {modalContent}
  </Drawer>
  :
  createPortal(<div>
    <div className="modal-back" style={{zIndex: 106}} onClick={onClose} />
    <div className="modal alt-text-help-modal" onClick={e => e.stopPropagation()}>
      <div onClick={onClose} className="close-btn"><CloseOutlined/></div>
      {modalContent}
    </div>
  </div>, document.getElementById('modals')!) : null;
}
